import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/data-access/auth.service';

/** Protects routes that require authentication */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};

/** Protects routes that require both authentication AND a selected company */
export const companyGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) {
    router.navigate(['/login']);
    return false;
  }
  if (!auth.selectedCompany()) {
    router.navigate(['/companies']);
    return false;
  }
  return true;
};

/** Redirects already-authenticated users away from the login page */
export const loginGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) {
    router.navigate(auth.selectedCompany() ? ['/overview'] : ['/companies']);
    return false;
  }
  return true;
};
